import { MasterWrapper } from "./styles";
import CustomEmail from "../CustomEmail";
import WhatsappBox from "../WhatsappBox";
import CustomPage from "../CustomPage";
import { useLocation } from "react-router-dom";

const FormEmail = () => {

  const selectedMenu = useLocation();


  return (
    <MasterWrapper>
      {selectedMenu.pathname == "/personalizar/email" || selectedMenu.pathname === "/personalizar" ? <CustomEmail /> : null}
      {selectedMenu.pathname == "/personalizar/checkout" ? <CustomPage /> : null}
    </MasterWrapper>
  );
};

export default FormEmail;
